import { Image } from "src/swsh-native";
import { ParsedScatteredSticker } from "../types";

const ScatteredSticker = ({ sticker }: { sticker: ParsedScatteredSticker }) => {
	return (
		<Image
			pointerEvents="none"
			src={sticker.url}
			alt=""
			dim={{
				width: sticker.size,
				height: sticker.size,
			}}
			style={{
				position: "absolute",
				width: sticker.size,
				height: sticker.size,
				transform: [
					{ translateX: sticker.x },
					{ translateY: sticker.y },
					{ rotate: `${sticker.rotation}deg` },
				],
			}}
			contentFit="contain"
		/>
	);
};
export default ScatteredSticker;
